import { Injectable } from '@angular/core';
import { PlatformReference } from '../../../base/lib/angular/platformreference';
import { CookieManager } from '../../../data/client/cookies/CookieManager';
import { LocalDataSetting, SettingsSet, SettingsSet_getSetting, SettingsSet_writeSetting, SingleSetting } from './settingsset';


export interface LocalDataStructure extends SettingsSet {
    deviceId: string | null;
    localDataAccepted: boolean;
    thirdPartiesAccepted: string[];
}

@Injectable({
    providedIn: 'root',
})
export class LocalDataService {

    private static localDataKey: string = "BaseTechnicalData";

    localData: LocalDataStructure;

    constructor(
    ) {
        this.localData = {
            deviceId: null,
            localDataAccepted: false,
            thirdPartiesAccepted: [],
            settings: []
        }

        //NOTE: you need to call load, but load has to be called AFTER the PlatformReference has been loaded
    }

    public load() {
        //MLLog.logDev("Local Service Setup: is LocalServiceBrowser", PlatformReference.isBrowser())

        if (PlatformReference.isBrowser() && LocalDataService.localDataKey in localStorage) {
            let localDataJson = localStorage.getItem(LocalDataService.localDataKey);
            if (localDataJson != null) {
                this.localData = JSON.parse(localDataJson) as LocalDataStructure;
                if (!this.localData.settings) {
                    this.localData.settings = [];
                }
                //MLLog.logDev("Local Data", this.localData);
            }
        }
    }

    private save() {
        if (PlatformReference.isBrowser()) {
            localStorage.setItem(LocalDataService.localDataKey, JSON.stringify(this.localData));
        }
    }

    public get deviceId() {
        return this.localData.deviceId;
    }

    public userAcceptTechnicalData() {
        this.localData.localDataAccepted = true;
        this.localData.deviceId = (new CookieManager()).generateDeviceId();
        this.save();
    }

    public userHasAccepted(key: string) {
        return this.localData.thirdPartiesAccepted.indexOf(key) >= 0;
    }

    public userAccept(key: string) {
        if (this.localData.localDataAccepted) {
            let index = this.localData.thirdPartiesAccepted.indexOf(key);
            if (index < 0) {
                this.localData.thirdPartiesAccepted.push(key);
                this.save();
            }
        }
    }

    public userRemove(key: string) {
        if (this.localData.localDataAccepted) {
            let index = this.localData.thirdPartiesAccepted.indexOf(key);
            if (index >= 0) {
                this.localData.thirdPartiesAccepted.splice(index, 1);
                this.save();
            }
        }
    }

    public getSetting(key: string): LocalDataSetting | null {
        return SettingsSet_getSetting(this.localData, key);
    }

    public writeSetting(key: string, group: SingleSetting[]): boolean {
        let result = SettingsSet_writeSetting(this.localData, key, group);
        this.save();

        //MLLog.logDev("Local Data", this.localData);
        return result;
    }
}